import { QueryOptions, useQuery, UseQueryOptions } from '@tanstack/react-query';
import classes from '../../api/classes';
import { getReportTypeIcon } from '../ReportsOverview/utils';

const { ReportTemplate } = classes;

export type ReportTemplate = {
	id: string;
	description?: string;
	settings: {
		type: string;
		title: string;
		showPieChart?: boolean;
		showTable?: boolean;
		showChart?: boolean;
		groupBy?: string;
	};
	hidden?: boolean;
	isAdminTemplate?: boolean;
	isUserTemplate?: boolean;
	isReportTemplate?: boolean;
	isDashboardTemplate?: boolean;
	userId?: string;
	createdDate?: string;
	isNew?: boolean;
	link: string;
	image: string;
};

const fetchTemplates = async () => {
	const allTemplates = await ReportTemplate.list();
	return allTemplates.map(template => ({
		...template,
		link: `/reports/templates/${template.id}`,
		image: getReportTypeIcon(template.settings.type),
	}));
};

export const useReportTemplates = (options?: Partial<UseQueryOptions<ReportTemplate[]>>) => {
	return useQuery({
		queryKey: ['reportTemplates'],
		queryFn: fetchTemplates,
		...options,
	});
};
